import * as tslib_1 from "tslib";
import toggleDarkModeThemeAction from 'owa-dark-mode-option/lib/actions/toggleDarkModeTheme';
import { orchestrator } from 'satcheljs';
import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import selectSurfaceActionsOption from '../actions/selectSurfaceActionsOption';
import saveSurfaceActionsOption from '../actions/saveSurfaceActionsOption';
export default function pinDarkModeToggleAction(isDarkModeTheme) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var pinnedActions;
        return tslib_1.__generator(this, function (_a) {
            pinnedActions = getFallbackValueIfNull(store.readSurfaceActions, getOptionsForFeature(OwsOptionsFeatureType.SurfaceActions)
                .readSurfaceActions).slice();
            // Select ToggleDarkMode and save the option.
            selectSurfaceActionsOption('readSurfaceActions', pinnedActions, 'ToggleDarkMode', isDarkModeTheme);
            saveSurfaceActionsOption();
            return [2 /*return*/];
        });
    });
}
orchestrator(toggleDarkModeThemeAction, function (msg) { return pinDarkModeToggleAction(msg.isDarkModeEnabled); });
//# sourceMappingURL=pinDarkModeToggleAction.js.map